import Axios from "axios";

export default {

  /**
   * 验证账号是否存在
   * @param {*} account_ticket 账号
   */
  isExist(
    account_ticket
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/checkTicketExists`, {
      params: {
        account_ticket
      }
    });
  },

  /**
   * 登录
   * @param {*} account_ticket 账号
   * @param {*} validate_code 验证码
   */
  login(
    account_ticket,
    validate_code
  ) {
    return Axios.post(`${process.env.VUE_APP_PREFIX}/login`, {
      account_ticket,
      validate_code
    });
  },

  /**
   * 是否登录
   */
  isLogin() {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/login/check`);
  },

  /**
   * 注销
   */
  logout() {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/logout`);
  }

}